import { PHONE, locationSchema } from "../structured-data-core";

export function getPittsburghStructuredData() {
  const url = "https://restorehair.com/locations/pennsylvania/pittsburgh/";
  const description =
    "Find out about your hair transplant options in Pittsburgh with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Pittsburgh", "322 North Shore Drive, Building 1B, Suite 200", "Pittsburgh", "PA", PHONE, url, description),
  ];
}
